export function validationLine(tabDonnees) {
  const errors = [];
  const produits = tabDonnees.map(line => {
    const allWeekLine = Object.keys(line)
      .filter(key => key[0] === 'S' && key.length === 3)
      .sort();
    const ids = line.Ids.split('|');
    const objectifs = allWeekLine.map((semaine, index) => ({
      semaine,
      id: ids[index],
      objectif: line[semaine],
    }));
    if (objectifs.some(o => o.objectif !== null && typeof o.objectif !== 'number')) {
      const semaines = objectifs
        .filter(o => o.objectif !== null && typeof o.objectif !== 'number')
        .map(o => o.semaine);
      errors.push({
        message: 'catalogue.popUpImportExcel.errorValueObjectif',
        parametres: {
          semaines: semaines.join(', '),
          libelle: line.Libelle,
        },
      });
    }
    return {
      objectifs,
      id: line.ProduitId,
      libelle: line.Libelle,
    };
  });
  return { produits, errors };
}

export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const errorMessage = error.message;
    if (errorMessage && errorMessage.indexOf('NO_DISPONIBILITE_OBJECTIF_RESEAU') === 0) {
      const elements = errorMessage.split('|')[0].split('@');
      messages.push({
        message: 'catalogue.popUpImportExcel.errorDispoObjectif',
        parametres: {
          libelle: elements[1],
          semaines: elements[2],
        },
      });
    }
  });
}
